import { utils } from '@/vjs/tabs';

export default {
    tabs: {
        ...utils
    }
};
